'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.someFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/someFromIndex.js
// module id = 424
// module chunks = 0